/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFridge = createReactComponent("outline", "fridge", "IconFridge", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M5 10h14", "key": "svg-1" }], ["path", { "d": "M9 13v3", "key": "svg-2" }], ["path", { "d": "M9 6v1", "key": "svg-3" }]]);

export { IconFridge as default };
//# sourceMappingURL=IconFridge.mjs.map
